angular.module('users_groups')

    .controller("usersGroupsListCtrl", ['LoginService', '$rootScope', '$scope',  'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$state', 'logService',
        function (LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state, logService) {


            $rootScope.title = $filter('translate')('users_groups.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('users_groups.title') }
            ];

            $scope.allowWrite = LoginService.permissionExist("USERS_WRITE");

            $scope.gridOptions= {
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    { name: 'name', displayName: $filter('translate')('general.name'), enableFiltering: true, enableHiding: false },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('general.button_edit'), action: 'ui-sref="users_groups.edit({id:row.entity.id})"; ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('general.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {
                    return Restangular.all('UsersGroups').getList(options)
                }
            };


            $scope.goToEdit = function (rowEntity) {
                $state.go("users_groups.edit", { id: rowEntity.id });
            };


            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('events_types.button_delete'),
                    message: $filter('translate')('users_groups.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('UsersGroups', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('users_groups.remove_success'));
                            $scope.gridOptions.gridApi.core.raise.itemDeleted($scope);

                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });


            }
        }])